import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { ConfigService } from 'src/app/services/config.service';
import { finalize } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-login-remote',
  templateUrl: 'login-remote.component.html',
  styleUrls: ['login-remote.component.scss'],
})
export class LoginRemoteComponent implements OnInit {
  constructor(
    private broadcastService: BroadcastService,
    private authService: AuthService,
    private userService: UserService,
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    let externalRedirection = false;

    this.route.queryParams.subscribe((params) => {
      this.authService
        .remoteLogin(params)
        .subscribe(
          (response) => {
            // TODO: legacy...
            if (response.redirectTo && !response.user) {
              externalRedirection = true;
              window.location.href = response.redirectTo;
              return;
            }

            this.broadcastService.broadcastLogin(true);
            this.userService.getUserData();
            this.authService.loadProfilePicture(response.user).subscribe();

            if (response.redirectTo) {
              window.location.href = response.redirectTo;
            } else {
              window.location.href = '/';
            }
          },
          (err) => {
            if (this.configService.get().showRemoteError) {
              throw err;
            }

            window.location.href = '/';
          }
        );
    });
  }
}
